/* !
 * jQuery shops v1.0.0
 * Copyright 2017, Connecty Inc.
 */
(function($){
	const a = 'is-active';
	const v = 'is-visible';
	if($('.js-topics-text').length) {
		// 文字数オーバーしたら「…」に
		if ($(window).width() <= 768) {
			cutTickerText(48);
		} else if ($(window).width() <= 1024) {
			cutTickerText(24);
		} else {
			cutTickerText(31);
		}

		function cutTickerText(_cnt) {
			$('.js-topics-text').each(function () {
				var rawText = $(this).text();
				if (rawText.length > _cnt) {
					$(this).text(rawText.substring(0, _cnt) + '...');
				}
			});
		}
	}
	
	/* ---------------------------------------------- functions ---------------------------------------------- */

})(window.jQuery);
